import { createDataLoader } from './createDataLoader.js';

const baseLoader = createDataLoader({
  jsonPath: '/data/equipment.json',
  dataKey: 'equipment',
  name: 'equipment.json'
});

export const EquipmentDataLoader = {
  ...baseLoader,

  async getEquipmentById(id) {
    return this.getById(id);
  },

  async getAllEquipment() {
    return this.getAll();
  },

  async getEquipmentByPrice(spiritPrice) {
    const equipment = await this.getAll();
    return equipment.filter(equip => equip.spiritPrice === spiritPrice);
  },

  getEquipmentByIdSync(id) {
    return this.getByIdSync(id);
  },

  formatModifiers(modifiers) {
    if (!modifiers) return '';

    const parts = [];
    if (modifiers.maxActiveCards) {
      const sign = modifiers.maxActiveCards > 0 ? '+' : '';
      parts.push(`${sign}${modifiers.maxActiveCards} Active Cards`);
    }
    if (modifiers.maxActiveEquipment) {
      const sign = modifiers.maxActiveEquipment > 0 ? '+' : '';
      parts.push(`${sign}${modifiers.maxActiveEquipment} Equipment Slots`);
    }
    if (modifiers.maxSpirit) {
      const sign = modifiers.maxSpirit > 0 ? '+' : '';
      parts.push(`${sign}${modifiers.maxSpirit} Max Spirit`);
    }
    if (modifiers.extraCardsPerTurn) {
      const sign = modifiers.extraCardsPerTurn > 0 ? '+' : '';
      parts.push(`${sign}${modifiers.extraCardsPerTurn} Cards/Turn`);
    }
    if (modifiers.startingMana) {
      const sign = modifiers.startingMana > 0 ? '+' : '';
      parts.push(`${sign}${modifiers.startingMana} Starting Mana`);
    }
    if (modifiers.startingGold) {
      const sign = modifiers.startingGold > 0 ? '+' : '';
      parts.push(`${sign}${modifiers.startingGold} Starting Gold`);
    }
    if (modifiers.startingDefense) {
      const sign = modifiers.startingDefense > 0 ? '+' : '';
      parts.push(`${sign}${modifiers.startingDefense} Starting Defense`);
    }
    if (modifiers.bonusDamage) {
      const sign = modifiers.bonusDamage > 0 ? '+' : '';
      parts.push(`${sign}${modifiers.bonusDamage} Attack Damage`);
    }
    if (modifiers.unitHealth) {
      const sign = modifiers.unitHealth > 0 ? '+' : '';
      parts.push(`${sign}${modifiers.unitHealth} Unit Health`);
    }
    return parts.join(', ');
  }
};
